
export const SENTRY_ERROR = {
  GOOGLE_COOKIE_HEADER: "googleCookie missing in response headers",
  FETCH_ABORT: "Abort error",
  ENV_CONFIG_LOAD: "Failed to fetch environment config",
  INVALID_LOB: "Invalid lob access initiated",
  PAGE_NOT_FOUND: "404 Page not found",
  API_ERROR: "Unknown API error occured",
};

export const LOGLEVEL = {
  INFO: "info",
  ERROR: "error",
};

export const CLIENT_START_ERROR_CODE = 400;

export const SERVER_END_ERROR_CODE = 599;
